import { BoxdWithSpacing } from '../../organisms/Grid';
import Grid from '@mui/material/Unstable_Grid2';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { ReactComponent as Phone } from '../../../images/phone.svg';
import { ReactComponent as Prescriptions } from '../../../images/prescriptions.svg';
import { ReactComponent as Calendartwo } from '../../../images/calendartwo.svg';
import { ReactComponent as DriveFolderUploadOutlinedIcon } from '../../../images/drive_folder_upload.svg';
import { CardItemPayment, CardItemPaymentRoot } from './style';
import Button from '@mui/material/Button';

interface ValueCardsItensProps {
  icon: JSX.Element;
  title: string;
  description: string;
}

const valueCardsItens: ValueCardsItensProps[] = [
  {
    icon: <DriveFolderUploadOutlinedIcon width={'32px'} />,
    title: 'Envie exames',
    description: 'Compartilhe os resultados dos seus exames com a sua equipe de cuidados'
  },
  {
    icon: <Prescriptions width={'32px'} />,
    title: 'Visualize resultados e receitas',
    description: 'Acesse os arquivos a qualquer momento e de qualquer dispositivo'
  },

  {
    icon: <Calendartwo width={'32px'} />,
    title: 'Gerencie seu agendamento',
    description: 'Veja a agenda completa e, se necessário, faça alterações de maneira rápida e fácil'
  }
];

const KnowPlataform = () => {
  return (
    <>
      <BoxdWithSpacing>
        <Grid container>
          <Grid
            xs={12}
            md={4}
            display={'flex'}
            flexDirection={{ xs: 'column-reverse', md: 'column' }}
            maxHeight={{ xs: 'max-content', md: 0 }}
          >
            <Box>
              <Typography variant="h2">Conheça a sua plataforma exclusiva de auto atendimento</Typography>
            </Box>
            <Box mt={{ xs: 0, md: 3 }} mb={3}>
              <Phone />
            </Box>
          </Grid>

          <Grid xs={12} md={7} mdOffset={1}>
            <Box sx={{ display: { xs: 'block', md: 'none' }, pt: 3, pb: 3 }}>
              <Button
                variant="contained"
                fullWidth
                href={process.env.REACT_APP_URL_MYACCOUNT || '#'}
                target="_self"
                sx={{ letterSpacing: 0 }}
              >
                Entrar na minha conta
              </Button>
            </Box>

            <CardItemPaymentRoot>
              {valueCardsItens.map((resp: ValueCardsItensProps, index: number) => {
                return (
                  // <GridItemPayment key={index} item xs={12} md={12} lg={6} className={`item-${index}`}>
                  <CardItemPayment key={index}>
                    <Box>
                      <Box sx={{ mb: 2 }}>{resp.icon}</Box>
                      <Box>
                        <Typography variant="body1B">{resp.title}</Typography>
                        <Typography mt={1} variant="body1">
                          {resp.description}
                        </Typography>
                      </Box>
                    </Box>
                  </CardItemPayment>
                  // </GridItemPayment>
                );
              })}
            </CardItemPaymentRoot>

            <Box sx={{ display: { xs: 'none', md: 'block' }, pt: 3 }}>
              <Button
                variant="contained"
                href={process.env.REACT_APP_URL_MYACCOUNT || '#'}
                target="_self"
                sx={{ letterSpacing: 0 }}
              >
                Entrar na minha conta
              </Button>
            </Box>
          </Grid>
        </Grid>
      </BoxdWithSpacing>
    </>
  );
};
export default KnowPlataform;
